import { bcpTag } from './bcpTag.js';
import { COUNTRY_LOCALE } from './countryLocale.js';
import { countryCodeToCurrencyCode } from '@owner/currency';
const DEFAULT_COUNTRY = 'US';
const DEFAULT_CURRENCY = 'USD';
export const resolveLocale = (country, language) => {
    const resolvedCountry = country ?? DEFAULT_COUNTRY;
    const currency = countryCodeToCurrencyCode[resolvedCountry];
    const resolvedLanguage = language ?? COUNTRY_LOCALE[resolvedCountry].language;
    return {
        country: resolvedCountry,
        currency: currency ?? DEFAULT_CURRENCY,
        distanceUnit: COUNTRY_LOCALE[resolvedCountry].distanceUnit,
        language: resolvedLanguage,
        tag: bcpTag(resolvedCountry, resolvedLanguage),
    };
};
/**
 * A historical or already-placed order must render from its own persisted
 * currency, never re-derived from the guest's current brand/flag state — use
 * this instead of a live resolver for past-order displays.
 */
export const US_LOCALE = resolveLocale();
//# sourceMappingURL=resolveLocale.js.map